<template >
  <div >
    <el-row class="table-grid-content">
      <el-col :span="3" >
        <el-input v-model="selecttypeName" placeholder="请输入标题"></el-input>
      </el-col>
      <el-col :span="3" class="grid" :gutter="1" style="margin-left:0.5rem;">
        <el-button type="success" @click="selectinit" icon="el-icon-search">搜索</el-button>
      </el-col>
      <el-col :span="2" class="grid" :gutter="15" style="margin-left: -2rem">
        <el-button type="primary" @click="addParamete()">增加</el-button>
      </el-col>
    </el-row>

    <el-table :data="parameterData" border style="width: 100%;margin-top: 1rem;">
      <el-table-column prop="id" label="id" v-if="show"></el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="conent" label="内容" ></el-table-column>
      <el-table-column prop="version" label="版本号" ></el-table-column>
      <el-table-column prop="insertDate" label="创建时间" ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="parameterEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="parameterDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>


    <el-pagination
      @size-change="sizeChange"
      @current-change="currentChange"
      :page-sizes="[10]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="page.totalRecords">
    </el-pagination>


    <!--新增-->
    <el-dialog title="新增用户" :visible="addParameteForm" size="tiny" :modal-append-to-body='false' @close='closeDialog'>
      <el-form id="#addsForm" ref="addsForm" :model="addsForm" label-width="150px">
        <el-form-item label="标题" prop="title">
          <el-input  v-model="addsForm.title" max-length="10"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="conent">
          <el-input v-model="addsForm.conent"></el-input>
        </el-form-item>
        <el-form-item label="版本号" prop="version">
          <el-input v-model="addsForm.version"></el-input>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="studentAdd()">确定</el-button>
          <el-button @click="addParameteForm = false;">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--修改-->
    <el-dialog title="修改用户" :visible="editParameteForm" size="tiny" :modal-append-to-body='false' @close='closeDialog'>
      <el-form id="#editsForm" ref="editsForm" :model="editsForm" label-width="150px">

        <el-input  v-model="editsForm.id" v-if="value"></el-input>

        <el-form-item label="标题" prop="title">
          <el-input  v-model="editsForm.title" max-length="10"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="conent">
          <el-input v-model="editsForm.conent"></el-input>
        </el-form-item>
        <el-form-item label="版本号" prop="version">
          <el-input v-model="editsForm.version"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="studentEdit()">确定</el-button>
          <el-button @click="editParameteForm = false;">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>   </div>
</template>

<script>
  export default {
    data(){
      return{
        checkedCities:[],
        value:false,
        show:false,
        addParameteForm:false,
        editParameteForm:false,
        parameterData:[],
        selecttypeName:"",
        checkMenu:[],
        page:{
          pageSize: 10, //每页条数,  默认10条
          totalRecords: 0, //总条数
          totalPages: 0, //总页数
          pageNum:0,
          title:''
        },

        addsForm:{

          title:'',
          conent:'',
          version:'',
          roles:[]
        }
        ,
        editsForm:{
          id:'',
          title:'',
          conent:'',
          version:'',
          userName:'',
          loginName:'',
          roles:[]
        },
        apiUrl:''

      }
    },
    created(){
      this.apiUrl = localStorage.aipUrl
    },
    mounted(){
      this.init();
    },
    methods:{
      handleCheckedCitiesChange(val){
        console.log(val,"选中的值")
      },
      enabledFormat(row, column) {
        if (row.enabled === 1) {
          return '正常'
        } else  {
          return '已禁用'
        }
      },
      selectinit(){
        this.page.pageNum=0;
        this.init();
      },

      init(){
        this.parameterData=[];
        let {pageNum,pageSize}=this.page;
        this.axios({
          method:'post',
          url:`${this.apiUrl}/releaseVersion/selectVersionAll?`+(new Date()).valueOf(),
          data: {
            pageNum: this.page.pageNum,
            pageSize: this.page.pageSize,
            title: this.selecttypeName


          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
        }).then(res=>{
          if(res.data.stateCode==200){
            this.page.totalRecords=res.data.data.totalRecords; //总条数
            const studentArray=res.data.data.updateRecords;
            this.parameterData=studentArray;
          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }
        }).catch(error=>{

        })


      },
      // 每页显示多少条数据
      sizeChange(val) {
        this.page.pageSize = val;
        this.init();
      },
//翻页
      currentChange(val) {
        this.page.pageNum=val-1;
        console.log(this.page.pageNum);
        this.init();
      },
// 点击模态框关闭按钮关闭模态框
      closeDialog(){
        this.addParameteForm = false;
        this.editParameteForm = false;
      },
// 点击新增按钮
      addParamete(){
        this.addsForm={};
        this.checkedCities=[];
        this.getRoleCheck(1);
        //原来隐藏的新增信息模态框显示
      },
      getRoleCheck(isAdd){
        if(isAdd===1){
          this.addParameteForm = true;
        }
      },
//确定
      studentAdd(){
        let parameteList=this.addsForm;
        let {userName,loginName} = parameteList;
//判断数据是否为空
        if(userName==''||loginName==''){
          this.$message.error('新增内容每一项都不准为空')
        }else{
//每一条都不为空时才向后台发送http请求
          this.axios({
            method:'post',
            url:`${this.apiUrl}/releaseVersion/insertVersion?`+(new Date()).valueOf(),
            data: {
              title: this.addsForm.title,
              conent: this.addsForm.conent,
              version: this.addsForm.version
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              'Authorization': sessionStorage.getItem("token")
            }
          }).then(res=>{
            if(res.data.stateCode==200){
              this.$set(this.addsForm,{});
              this.init();   //重新渲染数据列表
              this.addParameteForm = false;
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
            }else if(res.data.stateCode==403){
              this.$message.error("您没有相应操作权限，请联系系统管理员！");
            }else{
              this.$message.error(res.data.msg);
            }
          }).catch(error=>{

          })


        }
      },
// 点击修改修改按钮
      parameterEdit(index,row){
        this.editParameteForm = true;
        this.axios({
          method:'post',
          url:`${this.apiUrl}/releaseVersion/selectVersionById?`+(new Date()).valueOf(),
          data: {
            id: row.id,

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
        }).then(res=>{
          if(res.data.stateCode==200){
            this.editsForm.id=res.data.data.id;
            this.editsForm.conent=res.data.data.conent;
            this.editsForm.title=res.data.data.title;
            this.editsForm.version=res.data.data.version;

          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }

        }).catch(error=>{
          console.log("error");
        })

        //编辑信息模态框显示
        //  this.editsForm = Object.assign({}, row);  获得所有数据显示在编辑信息模态框里面
      },
//修改确定
      studentEdit(){
          this.axios({
            method:'post',
            url:`${this.apiUrl}/releaseVersion/updateVersion?`+(new Date()).valueOf(),
            data: {
              id: this.editsForm.id,
              title: this.editsForm.title,
              conent: this.editsForm.conent,
              version: this.editsForm.version

            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              'Authorization': sessionStorage.getItem("token")
            }
          }).then(res=>{
            if(res.data.stateCode==200){
              this.init();   //重新渲染数据列表
              this.editParameteForm = false;
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
            }else if(res.data.stateCode==403){
              this.$message.error("您没有相应操作权限，请联系系统管理员！");
            }else{
              this.$message.error(res.data.msg);
            }
          }).catch(error=>{

          })
      },
      parameterDelete(row){
        this.$confirm('此操作将永久删除用户 ' + row.userName + ', 是否继续?', '提示', { type: 'warning' })
          .then(() => { // 向服务端请求删除
            this.axios({
              method:'post',
              url:`${this.apiUrl}/releaseVersion/deleteVersion?`+(new Date()).valueOf(),
              data: {
                id:row.id,

              },
              headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': sessionStorage.getItem("token")
              }
            }).then(res=>{
              if(res.data.stateCode==200){
                this.init();   //重新渲染数据列表getManageUser
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
              }else if(res.data.stateCode==403){
                this.$message.error("您没有相应操作权限，请联系系统管理员！");
              }else{
                this.$message.error(res.data.msg);
              }
            }).catch(error=>{

            })
          }) .catch(() => {
          this.$message.info('已取消操作!');
        });
      }
    }
  }
</script>

<style scoped>


  .el-table /deep/ th{
    background-color: #EEEFF1;
  }

</style>



// WEBPACK FOOTER //
// src/views/releaseVersion.vue